<!-- -*- mode: vue -*- -->
<template>
  <div>
    <v-row no-gutters>
      <v-col>

        <v-row class="mgmt-panel">
          <Breadcrumbs :breadcrumbs="breadcrumbs" />
          <v-spacer></v-spacer>
          <div class="mgmt-panel-buttons" :class="{ 'mgmt-panel-buttons-mobile': device === 'mobile' }">
<!--           <XlsButton
            :pendingXls="pendingXls"
            @generateXls="generateXls"
          />
          <Columns
            class="mr-2"
            :columns="columns"
            :initialFields="fields"
            :viewName="viewName"
            @filteredLoad="filteredLoad"
          /> -->
            <HrFilter
              :query="initialQuery"
              :count="count"
              :filterPending="filterPending"
              :countTotal="countTotal"
              @filteredLoad="filteredLoad"
            />
          </div>
        </v-row>

        <v-card-title>Приняты:</v-card-title>
          <v-data-table
must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersEmployment"
            :loading="loading"
            :items="items.hired"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsEmployment" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-card-title>Уволены:</v-card-title>
          <v-data-table
must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersDismission"
            :loading="loading"
            :items="items.fired"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsDismission" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>


    </v-col>
  </v-row>

  <Confirmation
  :opened="confirmation.opened"
  :title="confirmation.title"
  :text="confirmation.text"
  :pendingSave="confirmation.pendingSave"
  @confirm="confirmConfirmationAction"
  @cancel="cancelConfirmationAction"
  />
  </div>
</template>

<script>
import IndexMixin from '@/views/Index.vue'
import ReportMixin from '@/views/Report.vue'
import Columns from '@/components/Columns'
import HrFilter from '@/components/filters/HrFilter'
import moment from 'moment'

export default {
  components: {
    HrFilter,
    Columns
  },
  mixins: [IndexMixin, ReportMixin],
  data: function () {
    return {
      modelName: 'Unit',
      viewName: 'unit_report',
      viewTitle: 'Отчет по сотрудникам',

      urlList: 'report/hr/',

      initialQuery: {
        date_start: moment(new Date().setDate(new Date().getDate() - 1 * 7)).format('DD.MM.YYYY'),
        date_end: moment(new Date()).format('DD.MM.YYYY')
      },

      columnsEmployment: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Сотрудник', align: 'left', width: 200, sortable: true, value: 'fio_initials', default: true },
        { text: 'Дата приема', align: 'left', width: 150, sortable: true, value: 'work__date_entry', default: true },
        { text: 'Организация', align: 'left', width: 150, sortable: true, value: 'work__organization', default: true },
      ],

      columnsDismission: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Сотрудник', align: 'left', width: 200, sortable: true, value: 'fio_initials', default: true },
        { text: 'Дата увольнения', align: 'left', width: 150, sortable: true, value: 'work__date_dismission', default: true },
        { text: 'Организация', align: 'left', width: 150, sortable: true, value: 'work__organization', default: true },
      ]
    }
  },
  computed: {
    headersEmployment () {
      return this.columnsEmployment.filter(column => (this.fieldsEmployment.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsEmployment () {
      return this.columnsEmployment.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersDismission () {
      return this.columnsDismission.filter(column => (this.fieldsDismission.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsDismission () {
      return this.columnsDismission.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

  },
}
</script>

<style>
</style>
